export interface Avatar {
  id: string;
  name: string;
  age: string;
  gender: string;
  accent: string;
  country: string;
  culturalRepresentation: string;
  description: string;
  presentationStyle: string;
  role: string;
  thumbnail: string;
  thumbnailNoBackground: string;
  videoPreview: string;
  voiceId: string;
}

export enum ScriptStyle {
  Review = 'review',
  Reaction = 'reaction',
  Professional = 'professional',
  Neutral = 'neutral',
}

export enum Audience {
  GenZ = 'gen_z',
  Millennials = 'millennials',
  GenX = 'gen_x',
  Students = 'students',
  YoungProfessionals = 'young_professionals',
  ParentsFamilies = 'parents_families',
  Seniors = 'seniors',
}

export enum VideoScriptKind {
  ProblemSolution = 'problem_solution',
  HowTo = 'how_to',
  Review = 'review',
  Testimonials = 'testimonials',
  Challenges = 'challenges',
}

export enum CallToAction {
  BuyNow = 'buy_now',
  GetStarted = 'get_started',
  BuildBuzz = 'build_buzz',
  DriveTraffic = 'drive_traffic',
  GrowList = 'grow_list',
  ScheduleDemo = 'schedule_demo',
  GetDownload = 'get_download',
}

export enum Platform {
  Instagram = 'instagram',
  TikTok = 'tiktok',
  YouTube = 'youtube',
  LinkedIn = 'linkedin',
  Facebook = 'facebook',
  XTwitter = 'x_twitter',
  Reddit = 'reddit',
  Pinterest = 'pinterest',
  Snapchat = 'snapchat',
  Threads = 'threads',
}

export enum Tone {
  Friendly = 'friendly',
  Expert = 'expert',
  Hype = 'hype',
  Calm = 'calm',
  Playful = 'playful',
  Serious = 'serious',
}

export interface ScriptConfiguration {
  scriptStyle: ScriptStyle;
  specialRequests?: string | null;
  product?: string | null;
  targetAudience?: Audience | null;
  scriptType?: VideoScriptKind | null;
  callToAction?: CallToAction | string | null;
  targetPlatform?: Platform | null;
  tone?: Tone | null;
}

export interface AiAvatarGenerateScriptRequest {
  assetId: string;
  scriptConfigurations: ScriptConfiguration[];
}

export interface GeneratedScript {
  title: string;
  script: string;
  inputScriptConfiguration: ScriptConfiguration;
}

export interface AiAvatarGenerateScriptResponse {
  generatedScripts: GeneratedScript[];
}

export interface Voice {
  id: string;
  name: string;
  voiceId: string;
  voicePreview: string;
  age: string;
  gender: string;
  useCase: string;
  category: string;
  accent: string;
}

export interface AiAvatarGenerateVideoRequest {
  assetId: string;
  avatar: Avatar;
  script: string;
}

export type AiAvatarGenerateVideoResponse = string;

export interface TtsAudioRequest {
  voice: Voice;
  script: string;
}

export type TtsAudioResponse = string;
